import { useEffect } from 'react'

import { Query, QueryClient } from '@tanstack/react-query'

const queryClients = new Set<QueryClient>()

const useRegisterQueryClient = (queryClient: QueryClient) => {
  useEffect(() => {
    queryClients.add(queryClient)
    return () => {
      queryClients.delete(queryClient)
    }
  }, [queryClient])
}

const isLoanQuery =
  (loanId: string) =>
  ({ queryKey }: Query) =>
    queryKey.some((part, index) => part === loanId && queryKey[index - 1] === 'loans')

const invalidateLoanQueries = (loanId: string) =>
  Promise.all([...queryClients].map((queryClient) => queryClient.invalidateQueries({ predicate: isLoanQuery(loanId) })))

export { invalidateLoanQueries, useRegisterQueryClient }
